<template>
    <div :class="type == 'MyPrj' ? 'prj_rate' : ''">        
		
		<div class="ptcp_period" v-if="type == 'MyPrj'">
			<div>
				<span class="tit blue">참 여 율</span>
				<span class="date blue ml-2"><strong>{{per}}</strong>%</span>
			</div>			
			<div>
				<span class="tit">참여기간</span>
				<span class="date ml-2">{{recrStartYyyymmdd | date('yyyy.MM.dd')}} - {{recrEndYyyymmdd | date('yyyy.MM.dd')}}</span>
			</div>
			<div>
				<span class="tit">참여분야</span>
				<span class="date ml-2">{{workCont}}</span>
			</div>
		</div>	

		<template v-else>
			<div class="tit">프로젝트 참여율</div>
			<div class="rate">{{ per }}%</div>
			<!-- <div :class="type == 'MyPrj' ? 'rate_img' : 'rate'"><img :src="'/images/tec/prj/' + per + '_percent.png'" alt="수행율이미지"/></div> -->
			<div class="rate"><img :src="'/images/tec/prj/' + per + '_percent.png'" alt="수행율이미지"/></div>
			<div class="ptcp_period">
				<div>
					<span class="term">참여기간</span>
					<span class="date ml-2">{{recrStartYyyymmdd | date('yyyy.MM.dd')}} - {{recrEndYyyymmdd | date('yyyy.MM.dd')}}</span>
				</div>
			</div>
		</template>		
    </div>  
</template>

<script>

/**
 * 프로젝트 참여율
 * 
 * props :
 *          type : 구분
 *          recrStartYyyymmdd	 : 참여시작일 (YYYYMMDD)
 *          recrEndYyyymmdd		 : 참여종료일 (YYYYMMDD)
 */
export default {

    props: {
        type				: String,// 구분
		recrStartYyyymmdd	: String,// 참여시작일
        recrEndYyyymmdd		: String,// 참여종료일
		workCont			: String,// 참여분야(모집분야)
    },

	data() {
		return {};
	},
	methods: {		
	},
	computed: {
		per(){
			var nowYmd = new Date().format('yyyyMMdd');

			if(this.recrStartYyyymmdd == this.recrEndYyyymmdd){
				if(nowYmd <= this.recrStartYyyymmdd) return 0;
				else return 100;
			}

			if(nowYmd < this.recrStartYyyymmdd) return 0;
			else if(nowYmd > this.recrEndYyyymmdd) return 100;

			var now   = this.$format.date(nowYmd, 'date');
			var start = this.$format.date(this.recrStartYyyymmdd, 'date');
			var end   = this.$format.date(this.recrEndYyyymmdd, 'date');
			var per   = (now - start) / (end - start)  * 10;

			if(per >=  9) return  90;
			else if(per <=  1) return  10;
			else return Math.floor(per) * 10;
		}
	}
};
</script>
